import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import DashboardLayout from "@/components/DashboardLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Overview from "@/pages/Overview";
import CompaniesPage from "@/pages/CompaniesPage";
import EmployeesPage from "@/pages/EmployeesPage";
import AttendancePage from "@/pages/AttendancePage";
import LeavesPage from "@/pages/LeavesPage";
import PayrollPage from "@/pages/PayrollPage";
import PayslipsPage from "@/pages/PayslipsPage";
import PayslipView from "@/pages/PayslipView";
import CalculatorPage from "@/pages/CalculatorPage";
import AnnouncementsPage from "@/pages/AnnouncementsPage";
import DocumentsPage from "@/pages/DocumentsPage";
import HelpdeskPage from "@/pages/HelpdeskPage";
import ExpensesPage from "@/pages/ExpensesPage";

function RoleRedirect({ children }) {
  const { user } = useAuth();
  if (!user) return children;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="employees" element={<EmployeesPage />} />
              <Route path="attendance" element={<AttendancePage />} />
              <Route path="leaves" element={<LeavesPage />} />
              <Route path="payroll" element={<PayrollPage />} />
              <Route path="payslips" element={<PayslipsPage />} />
              <Route path="payslips/:id" element={<PayslipView />} />
              <Route path="calculator" element={<CalculatorPage />} />
              <Route path="announcements" element={<AnnouncementsPage />} />
              <Route path="documents" element={<DocumentsPage />} />
              <Route path="helpdesk" element={<HelpdeskPage />} />
              <Route path="expenses" element={<ExpensesPage />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
